import "./Home.css";
import { InviteForm, Bubble, SiteNav, SiteFooter, A, useSeo } from "./_site";

export default function Home() {
  useSeo(
    "Remy | Your life, in a text",
    "Remy helps you keep up with email, your calendar, reminders and everyday life through a simple text conversation."
  );

  const capabilities = [
    { img: "email.webp", title: "Email", sub: "Stay on top of what matters" },
    { img: "calendar.webp", title: "Calendar", sub: "Know what's next" },
    { img: "reminders.webp", title: "Reminders", sub: "Never miss the important stuff" },
    { img: "everyday-help.webp", title: "Everyday help", sub: "Get quick answers and follow-ups" },
  ];
  const benefits = [
    { img: "remembers.svg", title: "Remembers", sub: "what matters" },
    { img: "schedule.svg", title: "Keeps up with", sub: "your schedule" },
    { img: "followups.svg", title: "Helps with", sub: "follow-ups" },
    { img: "bring-back.svg", title: "Brings important", sub: "things back up" },
  ];

  return (
    <div className="remy-home" data-testid="remy-home">
      <SiteNav />

      {/* SECTION 1 — HERO */}
      <header className="rh-hero" id="top">
        <div className="rh-wrap rh-hero__inner">
          <div className="rh-hero__copy">
            <p className="rh-eyebrow">Your life, in a text</p>
            <img className="rh-hd rh-hd--hello" src={`${A}/hello-remy.png`} alt="Hello Remy." />
            <p className="rh-subhead">Life feels easier with Remy.</p>
            <p className="rh-body">
              Remy helps you keep up with email, your calendar, reminders, follow-ups, and all the
              everyday stuff you shouldn't have to keep in your head.
            </p>
            <div id="invite"><InviteForm idPrefix="hero" source="homepage_hero" /></div>
          </div>
        </div>
        <div className="rh-hero__photo">
          <img src={`${A}/hero.webp`} alt="A hand holding a phone texting with Remy by SMS" />
        </div>
      </header>

      {/* SECTION 2 — TEXT REMY */}
      <section className="rh-section rh-text" id="how">
        <div className="rh-wrap rh-text__grid">
          <div>
            <p className="rh-kicker">Just send a message.</p>
            <h2 className="rh-hdtext" data-testid="text-remy-heading">Text Remy</h2>
            <p className="rh-subhead rh-subhead--sm">Remy keeps up.</p>
            <p className="rh-lead">
              From your inbox to your calendar to everyday reminders — just text. Remy handles the rest.
            </p>
            <div className="rh-caps">
              {capabilities.map((c) => (
                <div className="rh-cap" key={c.title}>
                  <img className="rh-cap__ic" src={`${A}/icons/${c.img}`} alt="" aria-hidden />
                  <b>{c.title}</b>
                  <small>{c.sub}</small>
                </div>
              ))}
            </div>
          </div>

          <div className="rh-bubbles">
            <Bubble who="me">What emails need my attention today?</Bubble>
            <Bubble who="remy">Only one thing looks urgent. I'll summarize it for you.</Bubble>
            <Bubble who="me">What's on my calendar tomorrow?</Bubble>
            <Bubble who="remy">You have a meeting at 10 AM and you're free after 4:30.</Bubble>
            <Bubble who="me">Remind me to call my mom at 11.</Bubble>
            <Bubble who="remy">Got it — I'll remind you at 11.</Bubble>
          </div>
        </div>
      </section>

      {/* SECTION 3 — ASK REMY */}
      <section className="rh-section rh-ask" id="ask">
        <div className="rh-wrap rh-ask__inner">
          <div className="rh-ask__copy">
            <p className="rh-kicker">From reminders to replies</p>
            <h2 className="rh-hdtext" data-testid="ask-remy-heading">Ask Remy</h2>
            <p className="rh-subhead rh-subhead--sm">For the big stuff and the little stuff.</p>
            <p className="rh-lead">
              Whether it's a reminder, a follow-up, a quick answer, or figuring out what's next —
              just ask. Remy keeps life moving, so you can focus on what matters.
            </p>
            <div className="rh-benefits">
              {benefits.map((b) => (
                <div className="rh-benefit" key={b.title}>
                  <img className="rh-benefit__ic" src={`${A}/icons/${b.img}`} alt="" aria-hidden />
                  <span className="rh-benefit__txt"><b>{b.title}</b><small>{b.sub}</small></span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="rh-ask__photo">
          <img className="rh-askdevice__photo" src={`${A}/ask-phone.webp`} alt="An iPhone lock screen showing a text reminder from Remy" />
        </div>
      </section>

      {/* SECTION 4 — PRIVATE ACCESS */}
      <section className="rh-section rh-private" id="invite-band">
        <div className="rh-wrap rh-private__grid">
          <div className="rh-private__copy">
            <p className="rh-kicker">Private access</p>
            <h2 className="rh-want">Want in?</h2>
            <p className="rh-private__sub">We're opening Remy slowly.</p>
            <p className="rh-lead">
              A small group gets access first so we can make the experience feel right before
              opening it up more broadly.
            </p>
          </div>
          <div className="rh-private__card">
            <InviteForm idPrefix="finding" variant="card" source="homepage_bottom" />
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
